import React from 'react';
import { ChevronRight, MessageSquare } from 'lucide-react';
import PanelAvatar from '../../components/PanelAvatar';
import { SupportThread, TYPE_LABELS, flag, timeAgo } from '../../components/support/supportTypes';

export const threadName = (thread: SupportThread) => thread.user.full_name || thread.user.username || `Kullanıcı #${thread.user.id}`;

export default function SupportThreadList({ threads, loading, selected, open }: {
  threads: SupportThread[]; loading: boolean; selected: number | null; open: (id: number) => void;
}) {
  if (loading && !threads.length) return <div role="status" className="support-empty">Konuşmalar yükleniyor…</div>;
  if (!threads.length) return <div className="support-empty"><MessageSquare size={28} className="mx-auto text-gray-300" /><p className="mt-3 font-medium text-gray-700">Konuşma yok</p><p className="mt-1">Aramayı veya filtreyi değiştirebilirsiniz.</p></div>;
  return <ul className="support-list" aria-label="Destek konuşmaları">{threads.map(thread => {
    const type = thread.feedback_type ? TYPE_LABELS[thread.feedback_type] : null;
    return <li key={thread.id}><button className="support-row" aria-current={selected === thread.id ? 'true' : undefined} onClick={() => open(thread.id)}>
      <PanelAvatar name={threadName(thread)} url={null} initials={2} className="support-avatar" />
      <span className="min-w-0 flex-1">
        <span className="flex items-baseline justify-between gap-2"><strong className="truncate font-semibold text-gray-900">{threadName(thread)}</strong><span className="shrink-0 text-xs text-gray-400">{timeAgo(thread.last_message_at)}</span></span>
        {thread.title && <span className="block truncate text-sm font-medium text-gray-800">{thread.title}</span>}
        <span className="block truncate text-sm text-gray-500">{thread.preview}</span>
        <span className="mt-2 flex flex-wrap items-center gap-1.5 text-xs">
          {type && <span className={`support-chip ${type[1]}`}>{type[0]}</span>}
          <span className="support-chip bg-gray-100 text-gray-600">{flag(thread.language)} {thread.app_version || '—'}</span>
          {thread.status === 'resolved' && <span className="support-chip bg-green-50 text-green-700">Çözüldü</span>}
        </span>
      </span>
      {thread.unread > 0 ? <span className="support-unread">{thread.unread}<span className="sr-only"> okunmamış</span></span> : <ChevronRight size={18} className="shrink-0 text-gray-300 lg:hidden" />}
    </button></li>;
  })}</ul>;
}
